

const initialState = {
  isLoading: false,
  facility: {},
  suggestion: {},
  newUser: {},
  currentData:{},
  details: {},
  errors: null,
};

const facilityReducer = (state = initialState, action) => {
  switch (action.type) {
    case "suggestion_req_delete":
      return {
        ...state,
        isLoading: true,
      };
    case "suggestion_delete":
      return {
        ...state,
        isLoading: false,

        suggestion: action.payload,
      };
    case "suggestion_delete_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };

    case "suggestion_List_req":
      return {
        ...state,
        isLoading: true,
      };
    case "suggestion_List_Success":
      return {
        ...state,
        isLoading: false,

        suggestion: action.payload,
      };
    case "suggestion_List_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };

    case "facility_List_req":
      return {
        ...state,
        isLoading: true,
      };
    case "facility_List_Success":
      return {
        ...state,
        isLoading: false,

        facility: action.payload,
      };
    case "facility_List_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };
    case "facility_req_delete":
      return {
        ...state,
        isLoading: true,
      };
    case "facility_delete":
      return {
        ...state,
        isLoading: false,

        facility: action.payload,
      };
    case "facility_delete_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };
    case "add_facility_req":
      return {
        ...state,
        isLoading: true,
      };
    case "add_facility_success":
      return {
        ...state,
        isLoading: false,

        newUser: action.payload,
      };
    case "add_facility_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };
    case "edit_facility_req":
      return {
        ...state,
        isLoading: true,
      };
    case "edit_facility_success":
      return {
        ...state,
        isLoading: false,

        newUser: action.payload,
      };

    case "edit_facility_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };
    case "set_facility_details":
      return {
        ...state,
        laoding: false,
        currentData: action.payload,
      };
    case "reset_facility_details":
      return {
        ...state,
        laoding: false,
        currentData: {},
        newUser:{}
      };

    default:
      return state;
  }
};

export { facilityReducer };
